











































































import BaseButton from '@/components/reusable-components/controls/BaseButton.vue'
import { ButtonTheme, ButtonSize } from '@/utils/ButtonAttr'
import { Component, Prop } from 'vue-property-decorator'
import UpgradeModalPlan from '@/components/upgrade/modal/partials/UpgradeModalPlan.vue'
import ModalName from '@/utils/ModalName'
import UpgradeModalAdvantage from '@/components/upgrade/modal/partials/UpgradeModalAdvantage.vue'
import TranslationModule from '@/utils/TranslationModule'
import Button from '@/components/UI/Button.vue'
import FormInput from '@/components/reusable-components/form/FormInput.vue'
import ChargebeeMixin from '@/mixins/chargebee.mixin'
import { mixins } from 'vue-class-component'
import { ToastType } from '@/utils/ToastAttr'
import API from '@/services/API'

@Component({
    components: {
        UpgradeModalAdvantage,
        UpgradeModalPlan,
        BaseButton,
        FormInput,
        Button,
    },
})
export default class UpgradeModal extends mixins(ChargebeeMixin) {
    @Prop({ default: ModalName.CLUB_UPGRADE }) name!: string
    ButtonTheme: typeof ButtonTheme = ButtonTheme
    ButtonSize: typeof ButtonSize = ButtonSize
    TranslationModule: typeof TranslationModule = TranslationModule
    content = [
        {
            id: 1,
            advantage: 'Mises en relation ciblées avec l’ensemble du réseau international',
            proximity: true,
            worldwide: true,
        },
        {
            id: 2,
            advantage: 'Tous les événements en présentiel de ma région',
            proximity: true,
            worldwide: true,
        },
        {
            id: 3,
            advantage: 'Un événement en présentiel dans une autre région par an',
            proximity: true,
            worldwide: true,
        },
        {
            id: 4,
            advantage:
                'Tous les événements en présentiel partout dans le monde, sans limitations (hors conditions particulières)',
            proximity: false,
            worldwide: true,
        },
        {
            id: 5,
            advantage: 'Tous les événements en ligne',
            proximity: true,
            worldwide: true,
        },
        {
            id: 6,
            advantage: 'Un Relationship Manager dédié',
            proximity: true,
            worldwide: true,
        },
        {
            id: 7,
            advantage:
                'Un accompagnement personnalisé avec prise de rendez-vous lors de vos déplacements grâce à notre Trip Planner',
            proximity: false,
            worldwide: true,
        },
        {
            id: 8,
            advantage: 'Un accès à nos bureaux partout dans le monde',
            proximity: false,
            worldwide: true,
        },
    ]
    isLoadingPayloadChargebee = false
    contextToTrack: 'event' | 'workspace' | 'tripplanner' | '' = ''

    get displayDesktop() {
        return this.breakpoints.lg || this.breakpoints.xl
    }

    onOpen({ params }: any) {
        if (params.contextToTrack) {
            this.contextToTrack = params.contextToTrack
        }
    }
    close() {
        this.$modal.hide(ModalName.CLUB_UPGRADE)
    }

    onSelect() {
        if (!this.isLoadingPayloadChargebee) {
            this.isLoadingPayloadChargebee = true
        }
        this.openCheckoutModal({
            getPayloadRequest: async () => {
                const response = await API.getPayloadUpgradeMembership()

                return response.data
            },
            onSuccess: () => {
                this.isLoadingPayloadChargebee = false
                if (this.contextToTrack) {
                    window.analytics.track('leclub:upgrade-end_' + this.contextToTrack)
                }
                this.$notify({
                    text: 'Votre nouveau membership sera actif dans quelques minutes.',
                    type: ToastType.SUCCESS,
                })
                this.close()
            },
            onError: () => {
                this.isLoadingPayloadChargebee = false
            },
        })
    }
}
